import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material'

import SimAPI from '../../api/orbitV1/SimAPI'
import PageLayout from '../../common/Layout/Page/PageLayout'
import { ColorBoxContent } from '../../common/ui/colorBox'
import Pagination from '../../common/ui/Pagination'
import { SearchBarBox, SearchBarInput } from '../../common/ui/searchBar'

export default function OrderTable() {
  const SIM_LIMIT = 20
  const navigate = useNavigate()
  const { orderNo } = useParams()
  const [sims, setSims] = useState([])

  const getOrderSims = async () => {
    try {
      const simsFromOrders = await SimAPI.getSimsFromOrder(orderNo)
      if (simsFromOrders && simsFromOrders.data) {
        setSims(simsFromOrders.data)
      }
    } catch (error) {
      toast.error('Error getting sims!')
    }
  }

  useEffect(() => getOrderSims(), [])

  return (
    <PageLayout header={`Order #${orderNo}`}>
      <ColorBoxContent style={{ marginBottom: 12 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12
          }}
        >
          <SearchBarBox>
            <SearchBarInput placeholder='Search' />
          </SearchBarBox>
          <Pagination items={sims.length} limit={SIM_LIMIT} />
        </Box>
        <Box sx={{ marginBottom: '32px' }}>
          <Table>
            <TableHead>
              <TableRow>
                {['ICCID', 'MSISDN', 'Status'].map((header, index) => {
                  return (
                    <TableCell
                      key={`${header}-${index}`}
                      sx={{
                        backgroundColor: 'transparent',
                        color: '#000000'
                      }}
                    >
                      {header}
                    </TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {sims.map((sim) => (
                <TableRow key={sim._id}>
                  <TableCell>{sim.iccid}</TableCell>
                  <TableCell>{sim.msisdn}</TableCell>
                  <TableCell>
                    {sim.serviceInstanceId ? 'Success' : 'Pending'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}
        >
          <Button
            variant='secondary'
            onClick={() => navigate('orders')}
            sx={{ backgroundColor: 'transparent' }}
          >
            Back
          </Button>
        </Box>
      </ColorBoxContent>
    </PageLayout>
  )
}
